"use strict";
import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";

export default class HeaderTemplate extends Component {
    static propTypes = {
        linkClass: PropTypes.cssClass,
        style: PropTypes.style,
        isLoggedIn: PropTypes.value,
        isSecurity: PropTypes.bool,
        logIn: PropTypes.content,
        logOut: PropTypes.content,
        security: PropTypes.content,
        transitionBtn: PropTypes.transition
    };

    static defaultProps = {
        transitionBtn: "rollUp",
        isSecurity: true,
        isLoggedIn: "_internal.isLoggedIn",
        logIn: [{
            "type": "a",
            "content": ["Log In"],
            "href": "/signin?country.x=US"
        }],
        logOut: [{
            "type": "a",
            "content": "Log Out",
            "href": "../cgi-bin/webscr?cmd=_logout"
        }],
        security: [{
            type: "div",
            content: "Your security is our top priority"
        }]
    };

    render() {
        const {transitionBtn, isLoggedIn, isSecurity, logOut, security, logIn, logoClass, securityClass, headerContainerClass, loginBtnClass} = this.props;
        const {Transition, ...transprops} = transitionBtn;
        return (
            <header className={headerContainerClass} role="banner">
                <a href="https://www.paypal.com" className={logoClass}>PayPal</a>
                <Transition {...transprops}>
                    {isSecurity ?
                       <RenderContent key="security" content={security} className={securityClass}/> :
                       isLoggedIn ?
                           <RenderContent key="logOut" content={logOut} className={loginBtnClass}/> :
                           <RenderContent key="logIn" content={logIn} className={loginBtnClass}/>
                   }
                </Transition>
            </header>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/HeaderTemplate.jsx
 **/